import React from "react";
import {Navigate} from "react-router-dom";
import {Spin} from "antd";
import {useAuth} from "oidc-react";

const LoginCallback = () => {
    const {userData, isLoading} = useAuth();

    if (userData && !isLoading) return <Navigate to="/"/>;

    return (
        <div className="h-screen">
            <div className="flex justify-center items-center h-full">
                <Spin size="large" className="custom-spin"/>
            </div>
        </div>
    );
};

export default LoginCallback;
